import BaseRepository from "@/baseRepository/BaseRepository";
const faqquestionsResource = `/api/v1/faqquestions`;


export default{
  getFaqquestions(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${faqquestionsResource}`, {
      baseURL,
      headers,
      params
    });
  },
  createFaqquestions(obj={},baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${faqquestionsResource}`,obj, {
      baseURL,
      headers,
      params
    });
  },
  deleteFaqquestions(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${faqquestionsResource}/${id}`, {
      baseURL,
      headers,
      params
    });
  },
  getDetailsFaqquestions(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${faqquestionsResource}/${id}`, {
      baseURL,
      headers,
      params
    });
  },
  updateFaqquestions(id,obj={},baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${faqquestionsResource}/${id}`,obj, {
      baseURL,
      headers,
      params
    });
  },
  disableFaqquestions(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${faqquestionsResource}/${id}/disable`,{},{
      baseURL,
      headers,
      params
    });
  },
  enableFaqquestions(id,baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${faqquestionsResource}/${id}/enable`,{},{
      baseURL,
      headers,
      params
    });
  },

}